<template>

	<div class="NS-threeDropdown threeD--wrap">
		<div class="NS-threeDropdown__head">
			<a :href="`tel:${selected}`" class="NS-threeDropdown__head__tel">
				<i class="fa fa-phone"></i>{{ selected }}
			</a>
			<button
				class="NS-threeDropdown__switch drop"
				@click.prevent="switchOpen"
				:class="{active: isOpen}"
			></button>
		</div>
		<ul
			class="NS-threeDropdown__item--wrap threeD__animations left flex direction-column"
			:class="{active: isOpen}"
		>
			<li
				class="NS-threeDropdown__item flex align-center"
				v-for="(item, index) in list"
				:key="index"
				:style="{order: item.active ? -1 : 0}"
				@click.prevent="checkItem(item)"
			>
				<i class="fa fa-check" v-if="item.active"></i>
				<comment :is="item.country.toLocaleLowerCase()"></comment>
				{{ item.number }}
			</li>
		</ul>
	</div>

</template>


<script>

	import {getCookie, setCookie} from "@/plugin/cookie";
	import {threeDropdown} from "@/plugin/threeDropdown";

	export default {

		data: function () {
			return {
				selected: '',
				list: [
					{
						number: '+380 44 299 2222',
						country: 'UA',
						active: true
					},
					{
						number: '+7 495 145 21 08',
						country: 'RU',
						active: false
					},
					{
						number: '+1 302 319 9443',
						country: 'US',
						active: false
					},
					{
						number: '+44 20 8089 0951',
						country: 'UK',
						active: false
					}
				]
			}
		},
		methods: {
			initDropdown() {
				const cookiePhone = this.getCookie('phone');
				const replaceCookiePhone = cookiePhone.replace( /\+/g, ' ');
				const decodePhone = decodeURIComponent(replaceCookiePhone);
				this.selected = decodePhone
					? this.setActiveNumber(decodePhone)
					: this.list.find(el => el.active).number;
			},
			checkItem(item) {
				this.switchOpen();
				this.selected = item.number;
				setTimeout(() => {
					this.list.forEach(el => el.active = false);
					item.active = true;
				}, 200);

				this.setCookie('phone', item.number,  { expires: 60*60*24*7, domain: '.netpeaksoftware', path: '/'})
			},
			setActiveNumber(number) {
				this.list.forEach(el => el.active = false);
				this.list.find(el => el.number === number).active = true;
				return number;
			}
		},
		mounted() {
			this.initDropdown();
		},
		components: {
			ua: () => import('Components/subComponents/countryFlag/ua'),
			ru: () => import('Components/subComponents/countryFlag/ru'),
			us: () => import('Components/subComponents/countryFlag/us'),
			uk: () => import('Components/subComponents/countryFlag/uk'),
		},
		mixins: [getCookie, setCookie, threeDropdown]

	}

</script>